import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ITooltipSequence } from './i2g-tooltip-sequence.data';

@Injectable({
  providedIn: 'root',
})
export class I2gTooltipSequenceService {
  private _tooltipSubject: BehaviorSubject<ITooltipSequence> = new BehaviorSubject(
    null
  );
  tooltip$: Observable<ITooltipSequence> = this._tooltipSubject.asObservable();

  constructor() {}

  start(tooltipSequence: ITooltipSequence): void {
    this._tooltipSubject.next(tooltipSequence);
  }

  end(): void {
    this._tooltipSubject.next(null);
  }
}
